<template>
  <b-card class="mb-3 d-none d-md-block" no-body>
    <b-card-body style="padding-bottom: 0.2rem;">
      <b-row>
        <b-col sm="9">
          <h4 class="card-title mb-0">Регионы школ</h4>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-body class="pl-0">
      <div class="card-with-map-body">
        <div class="map-container">
          <div id="world-map"></div>
          <div id="map-table">
            <div>
              <b-badge @click="gotoRegionsOnTable" style="cursor:pointer"
                       v-if="tableType === 'classes'" variant="primary">
                <em class="fas fa-undo"></em>
              </b-badge>
              {{(regionSelected) ? 'Школы региона - '
              + subjectsOfRussia[regionSelected] :'Регионы школ'}}
            </div>
            <ag-grid-vue
              class="ag-theme-material ag-grid-for-map-stat"
              :columnDefs="columnDefs"
              :gridOptions="gridOptions"
              :rowData="rowData"
              @rowClicked="this.onTableRowClicked"
              @grid-ready="onGridReady"
              @gridSizeChanged="onGridSizeChanged"
              @rowDataChanged = "onRowDataChanged"
              @column-resized="onColumnResized">
            </ag-grid-vue>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import $ from 'jquery'
import _ from 'lodash'

import { subjectsOfRussia } from '@/config/config'

window.jQuery = require('jquery')
require('jvectormap')
require('../../../public/libs/jquery-jvectormap-ru-merc')
require('../../../public/libs/jquery-jvectormap-2.0.3.css')

export default {
  name: 'Geography',
  props: {
    loaded: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      classes: null,
      showClasses: true,
      tableType: 'regions',
      regions: [],
      regionsColors: [],
      rowData: [],
      columnDefs: [],
      columnsForRegions: [
        { headerName: 'Название', field: 'label', lockPosition: true },
        {
          headerName: 'Школ',
          suppressSizeToFit: true,
          field: 'count',
          lockPosition: true,
          width: 140
        }
      ],
      columnsForSchools: [
        { headerName: 'Название', field: 'title', lockPosition: true },
        {
          headerName: 'Учеников',
          suppressSizeToFit: true,
          lockPosition: true,
          field: 'count',
          width: 140
        }
      ],
      gridApi: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true
        },
        headerHeight: 40
      },
      subjectsOfRussia: {},
      regionSelected: null
    }
  },
  mounted() {
    this.subjectsOfRussia = subjectsOfRussia
    this.fetchStatsClassesStudentsDistribution()
    this.fetchGPClasses().then(() => {
      for (const school of this.gpSchools) {
        if (!this.regions.filter((p) => p.label
          === this.subjectsOfRussia[school.region]).length) {
          this.regions.push({
            label: this.subjectsOfRussia[school.region],
            count: 1
          })
          this.regionsColors[school.region] = 'contains'
        } else {
          this.regions.find((p) => p.label
            === this.subjectsOfRussia[school.region]).count += 1
        }
      }
      this.rowData = this.regions
      this.columnDefs = this.columnsForRegions
      this.gridApi.sizeColumnsToFit()
      this.createMap()
    })
  },
  methods: {
    ...mapActions({
      fetchGPClasses: 'content/fetchGPClassesForMap',
      fetchStatsClassesStudentsDistribution: 'statistics/fetchStatsClassesStudentsDistribution'
    }),
    gotoRegionsOnTable() {
      $('#world-map').vectorMap('get', 'mapObject').clearSelectedMarkers()
      this.regionSelected = null
      this.selectRegion('net')
      this.getTableForRegions()
    },
    onTableRowClicked(event) {
      if (this.tableType === 'regions') {
        $('#world-map').vectorMap('get', 'mapObject').clearSelectedMarkers()
        let code = ''
        for (const key of Object.keys(this.subjectsOfRussia)) {
          if (this.subjectsOfRussia[key] === event.data.label) {
            code = key
            break
          }
        }
        this.regionSelected = code
        this.selectRegion(code)
        this.getTableForSchools()
        if (code === 'RU-SPB') {
          $('#world-map').vectorMap('get', 'mapObject').setSelectedMarkers(['0'])
        } else if (code === 'RU-MSK') {
          $('#world-map').vectorMap('get', 'mapObject').setSelectedMarkers(['1'])
        }
      }
    },
    createMap() {
      const cities = []
      cities.push({
        latLng: [59.651816906418237, 30.976602499999964],
        name: 'Санкт-Петербург',
        lable: 'Санкт-Петербург',
        offset: [-15, 10],
        region: 'RU-SPB'
      })
      cities.push({
        latLng: [56.60747556511868, 37.812042999999984],
        name: 'Москва',
        lable: 'Москва',
        offset: [-12, 10],
        region: 'RU-MSK'
      })
      const component = this
      $('#world-map').vectorMap({
        map: 'ru_merc',
        zoomOnScroll: false,
        zoomButtons: false,
        panOnDrag: false,
        focusOn: {
          scale: 0.8,
          x: 0.5,
          y: 0.9
        },
        markersSelectable: true,
        markerStyle: {
          initial: {
            stroke: '#017ac3',
            'stroke-width': '1px',
            fill: 'white'
          }
        },
        markerLabelStyle: {
          initial: {
            // Add CSS properties here
            'font-size': '8px'
          }
        },
        markers: cities,
        labels: {
          markers: {
            render(index) {
              return cities[index].name
            },
            offsets(index) {
              return cities[index].offset
            }
          }
        },
        scaleColors: ['#C8EEFF', '#0071A4'],
        normalizeFunction: 'polynomial',
        hoverOpacity: 0.7,
        hoverColor: '#ffff0000',
        onRegionTipShow(e, el, code) {
          if (!['RU-NC', 'RU-VO', 'RU-CENTR', 'RU-SI', 'RU-NW', 'RU-SO', 'RU-UR', 'RU-FE'].includes(code)) {
            el.html(el.html())
          } else {
            e.preventDefault()
          }
        },
        backgroundColor: '#ffffff00',
        regionStyle: {
          initial: {
            fill: '#c5e7ff'
          }
        },
        series: {
          regions: [{
            scale: {
              contains: '#ffbf00',
              selected: '#ff0000'
            },
            attribute: 'fill',
            values: this.regionsColors
          }],
          markers: [{
            scale: {
              contains: '#ffbf00',
              selected: '#ff0000'
            },
            attribute: 'fill',
            values: this.regionsColors
          }]
        },
        onRegionClick(e, code) {
          if (component.regionSelected === code) {
            component.regionSelected = null
            component.selectRegion('net')
            component.getTableForRegions()
          } else if (component.regions.filter((p) => p.label
            === component.subjectsOfRussia[code]).length) {
            $('#world-map').vectorMap('get', 'mapObject').clearSelectedMarkers()
            component.regionSelected = code
            component.selectRegion(code)
            component.getTableForSchools()
          }
        },
        onMarkerClick(e, code) {
          if (component.regionSelected === cities[code].region) {
            component.regionSelected = null
            component.selectRegion('net')
            component.getTableForRegions()
          } else if (component.regions.filter((p) => p.label
            === component.subjectsOfRussia[cities[code].region]).length) {
            $('#world-map').vectorMap('get', 'mapObject').clearSelectedMarkers()
            component.regionSelected = cities[code].region
            component.selectRegion(cities[code].region)
            component.getTableForSchools()
          }
        }
      })
    },
    selectRegion(code) {
      const mapObject = $('#world-map').vectorMap('get', 'mapObject')
      for (const key of Object.keys(this.regionsColors)) {
        if (key === code) {
          this.regionsColors[key] = 'selected'
        } else {
          this.regionsColors[key] = 'contains'
        }
      }
      mapObject.series.markers[0].setValues(this.regionsColors)
      mapObject.series.regions[0].setValues(this.regionsColors)
    },
    getTableForSchools() {
      this.tableType = 'classes'
      this.columnDefs = this.columnsForSchools
      this.rowData = this.gpSchools.filter((p) => p.region === this.regionSelected)
    },
    getTableForRegions() {
      this.tableType = 'regions'
      this.columnDefs = this.columnsForRegions
      this.rowData = this.regions
    },
    onColumnResized() {
      this.gridApi.resetRowHeights()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
    },
    onRowDataChanged() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit()
      }
    }
  },
  computed: {
    ...mapGetters({
      gpClasses: 'content/getGPClasses',
      orgs: 'dicts/getOrganizations',
      statsClassesStudentsDistribution: 'statistics/getStatsClassesStudentsDistribution'
    }),
    gpSchools() {
      const titles = {}
      const schools = []
      this.gpClasses.filter((c) => c.position && !c.disabledAsSchool)
        .forEach((c) => {
          const old = titles[c.title.trim()]
          const dataForOrganization = this.statsClassesStudentsDistribution
            .find((p) => p.organizationId === c.id)
          if (dataForOrganization) {
            const maxYearWithData = Math.max
              .apply(null, Object.keys(dataForOrganization).filter((key) => !_.isNaN(Number(key))))
            if (old !== undefined) {
              if (dataForOrganization[maxYearWithData] !== '-') {
                const currentCount = schools.find((p) => p.id === old.id).count
                schools.find((p) => p.id === old.id).count = (currentCount === '-')
                  ? dataForOrganization[maxYearWithData]
                  : currentCount + dataForOrganization[maxYearWithData]
              }
            } else {
              titles[c.title.trim()] = c
              schools.push(c)
              schools[schools.length - 1].count = dataForOrganization[maxYearWithData]
            }
          }
        })
      return schools
    }
  }
}
</script>

<style lang="scss">
.card-with-map-body{
  height: 960px;
}
.ag-grid-for-map-stat {
  height: 300px;
  border-bottom: 1px solid #017ac3;
  margin-left: 20px;
  .ag-row .ag-cell {
    display: inline-flex;
    align-items: center;
    font-size: 15px;
    justify-content: center;
    text-align: center;
    white-space: normal;
    line-height: 1.4em !important;
  }
  .ag-row .ag-cell{
    padding: 0 !important;
  }
  .ag-header-cell-label {
    justify-content: center;
  }
}

#world-map {
  background-size: 70px 70px;
  background-image: linear-gradient(to right, #e8f5ff 1px, transparent 1px),
  linear-gradient(to bottom, #e8f5ff 1px, transparent 1px);
  min-width: 580px !important;
  height: 600px !important;
  text-align: center;
}
#map-table{
  height: 600px !important;
  text-align: center;
  border-left: 0;
  background-image: linear-gradient(to right, #e8f5ff 1px, transparent 1px),
  linear-gradient(to bottom, #e8f5ff 1px, transparent 1px);
}
@media screen and (min-width: 1250px) {
  #world-map {
    width: 70%;
    float: left;
  }
  #map-table{
    width: 30%;
    float: right;
    border-left: 1px solid rgba(1, 120, 186, 0.31);
  }
  .card-with-map-body{
    height: 650px;
  }
  .ag-grid-for-map-stat {
    height: 576px;
    border-bottom: 0px;
    margin-left: 0px;
  }

}
</style>
